import { render, staticRenderFns } from "./tenyear.vue?vue&type=template&id=8626f22c&scoped=true&"
import script from "./tenyear.vue?vue&type=script&lang=js&"
export * from "./tenyear.vue?vue&type=script&lang=js&"
import style0 from "./tenyear.vue?vue&type=style&index=0&id=8626f22c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8626f22c",
  null
  
)

export default component.exports